<div class="details-operation-container">
	<a id="close-dialog-alta" class="close-dialog" (click)="closeDialog()">
		<img src="assets/images/icons/close_dialog_icon.svg" alt="close">
	</a>
	<div class="details-operation-title primary-color">
		{{"CONTRACT_TITLE"|translate}}
	</div>
	<div class="details-operation-detail mt-4">
		<div class="amount p-2">
			<p class="subtitle mb-1">{{"titular"|translate}}</p>
			<p class="value">{{contractDetails.datos.nomTitular}}</p>
		</div>
		<div class="amount layout p-2">
			<p class="subtitle mb-1">{{"alias" | translate}}</p>
			<p class="value">{{contractDetails.datos.alias ? contractDetails.datos.alias : '--'}}</p>
		</div>

		<div class="receiver  p-2">
			<p class="subtitle mb-1">{{"Account" | translate}}</p>
			<p class="value">{{contractDetails.datos.cuenta ? contractDetails.datos.cuenta : '--'}}</p>
		</div>

		<div class="bank layout p-2" *ngIf="contractDetails.datos.clabeSpei">
			<p class="subtitle mb-1">{{"CLABE_SPEI" | translate}}</p>
			<p class="value">{{contractDetails.datos.clabeSpei ? contractDetails.datos.clabeSpei : '--'}}</p>
		</div>

		<div class="concept p-2" *ngIf="contractDetails.datos.clabeSpid">
			<p class="subtitle mb-1">{{"CLABE_SPID" | translate}}</p>
			<p class="value">{{contractDetails.datos.clabeSpid ? contractDetails.datos.clabeSpid : '--'}}</p>
		</div>

		<div class="bank p-2"
		[ngClass]="{'layout' : !contractDetails.datos.clabeSpei || (contractDetails.datos.clabeSpid && contractDetails.datos.clabeSpei), '' : contractDetails.datos.clabeSpid || (contractDetails.datos.clabeSpei && contractDetails.datos.clabeSpid) }">
			<p class="subtitle mb-1">{{"SWIFT_CODE" | translate}}</p>
			<p class="value">{{contractDetails.datos.codigoSwift ? contractDetails.datos.codigoSwift : '--'}}</p>
			<div class="d-flex align-items-center information-swift">
				<span>
					<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path
							d="M6.99967 0.332031C3.31967 0.332031 0.333008 3.3187 0.333008 6.9987C0.333008 10.6787 3.31967 13.6654 6.99967 13.6654C10.6797 13.6654 13.6663 10.6787 13.6663 6.9987C13.6663 3.3187 10.6797 0.332031 6.99967 0.332031ZM7.66634 10.332H6.33301V6.33203H7.66634V10.332ZM7.66634 4.9987H6.33301V3.66536H7.66634V4.9987Z"
							fill="#0098DD" />
					</svg>
				</span>
				<p>{{'SWIFT_INFO'|translate}}</p>
			</div>
		</div>
	</div>
	<div class="row mt-2">
		<div class="">
			<a (click)="downloadPDFdeposits($event)">
				<span class="subtitle mb-1">{{'Recibir Depositos'|translate}}</span>
			</a>
		</div>
	</div>
	<div class="row mt-4">
		<div class="col-12 share-container">
			<a (click)="download($event)">
				<img class="icon-success-share" src="assets/images/icons/download_icon.svg" alt="download">
				<span class="ml-3 message-success-share primary-color">{{'Descargar comprobante'|translate}}</span>
			</a>
		</div>
	</div>
</div>
